import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Toolkit {
  id: string;
  title: string;
  description: string;
  image: string;
  alt: string;
  userType: string;
  includes: string[];
}

interface FeaturedToolkitProps {
  toolkits: Toolkit[];
}

const FeaturedToolkit: React.FC<FeaturedToolkitProps> = ({ toolkits }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {toolkits.map((toolkit) => (
        <div
          key={toolkit.id}
          className="bg-card rounded-lg shadow-md overflow-hidden border border-border transition-all duration-300 hover:shadow-lg hover:scale-[1.02]"
        >
          <div className="relative h-48 overflow-hidden">
            <AppImage
              src={toolkit.image}
              alt={toolkit.alt}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-grounded-charcoal/80 to-transparent" />
            <div className="absolute bottom-4 left-4 right-4">
              <span className="px-3 py-1 bg-accent text-accent-foreground rounded-full text-xs font-cta font-bold">
                {toolkit.userType}
              </span>
            </div>
          </div>

          <div className="p-5">
            <h3 className="text-xl font-headline font-bold text-foreground mb-3">
              {toolkit.title}
            </h3>

            <p className="text-sm font-body text-muted-foreground mb-4">
              {toolkit.description}
            </p>

            <div className="space-y-2 mb-5">
              <p className="text-sm font-body font-semibold text-foreground">Includes:</p>
              {toolkit.includes.map((item, index) => (
                <div key={index} className="flex items-start space-x-2">
                  <Icon name="CheckCircleIcon" size={16} className="text-success mt-0.5 flex-shrink-0" />
                  <span className="text-sm font-body text-muted-foreground">{item}</span>
                </div>
              ))}
            </div>

            <Link
              href="#"
              className="block w-full py-2.5 bg-accent text-accent-foreground text-center rounded-md font-cta text-sm font-bold transition-all duration-300 hover:scale-105 hover:shadow-md"
            >
              Download Toolkit
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeaturedToolkit;